<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: reconcileReportForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form class="reconcile-report-container" [formGroup]="reconcileReportForm">
    <app-from-to-date
      [fromControl]="'fromDate'"
      [toControl]="'toDate'"
      [formGroupValue]="reconcileReportForm"
      [minSelectableDays]="60"
    ></app-from-to-date>

    <!-- Routes -->
    <ion-row>
      <ion-col size="12">
        <app-form-select
          formControlName="routes"
          [label]="CONSTS.ROUTE_LABEL"
          [options]="routes"
          [customClass]="'scan-type-dropdown report-select'"
        ></app-form-select>
      </ion-col>
    </ion-row>

    <!-- Note -->
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
